export const buildSessionSearchParams = ({ venueName, movieId, sessionDate, lat, lng, ticketClassId, search_distance }) => {
    const params = new URLSearchParams();
    if (venueName) params.set("venue_name", venueName);
    if (movieId) params.set("movie_id", movieId);
    if (sessionDate) params.set("session_date", sessionDate);
    if (lat) params.set("lat", lat);
    if (lng) params.set("lng", lng);
    if (ticketClassId) params.set("ticket_class_id", ticketClassId);
    if (search_distance) params.set("search_distance", search_distance);
    return params;
};
